'use strict';

var React = require('react');
var ReactForms = require('react-forms');
var Mapping = ReactForms.schema.Mapping;

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;

var Scalar = require('ofs/forms/scalars/Scalar');
var scalars = require('ofs/forms/scalars');
var ToggleSelect = require('ofs/forms/inputs/toggle-select');

var buildLayout = require('./layout');

var messages = {
  CALL_RES: gettext('Call reservations on %(telephone_number)s'),
  CALL_OTHER: gettext('Call our %(team_name)s team on %(telephone_number)s'),
  EMAIL: gettext('Email'),
  CALL: gettext('Call Me'),
  MESSAGE_LABEL: gettext('Message'),
  CONTACT_PREFERENCE_LABEL: gettext('How would you like us to contact you?')
};

var contactChoices = [
  {value: 'email', name: messages.EMAIL},
  {value: 'call', name: messages.CALL},
];

var contactMappings = {
  'email': require('../mappings/email').mapping,
  'call': require('../mappings/telephone').mapping
};

var buildSchema = function(contactPreference, defaultValues) {
  var Component = buildLayout(contactPreference);
  var topicMapping = require('../mappings/unit').mapping(defaultValues);
  var contactMapping = contactMappings[contactPreference](defaultValues);

  var fields = Object.assign(topicMapping, {
    message: scalars.TextScalar({
      label: messages.MESSAGE_LABEL
    }),
    contact_preference: Scalar({
      label: messages.CONTACT_PREFERENCE_LABEL,
      input: <ToggleSelect options={contactChoices} className="ignore-react-onclickoutside" />,
      defaultValue: 'email'
    })
  }, contactMapping);

  return Mapping({ component: Component }, fields);
};

module.exports = buildSchema;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/unit/schema.jsx
 **/